module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1dd444bf!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./~/@dolphinweex/weex-theme/packages/weex-theme-view/index.vue
// module id = 577
// module chunks = 0 1